<template>
    <div class="page_title_area">
        统计
    </div>
</template>

<script>
import mixins from "./Mixins";
export default {
mixins:[mixins],
created(){
    this.setLeftMenuShow_M(true);
    this.setLeftMenuIndex_M(0);
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/PartI/Statistics/components/statisticsTitle.vue